module.exports = __webpack_public_path__ + "media/images/flags/64/Ukraine-34b711b80fd3ac1b1370e6fa6ed0f85b.png";